import * as React from 'react';
import {useBiLogger} from '../../components/BiProvider/withBiLogger';
import {AppContext} from '../../machines/appMachine/AppContext';
import {createMachine} from '../../machines/appMachine/appMachine';
import {getTransactionInfo} from '../../services/cashier/getTransactionInfo';
import {useSiteInfo} from '../../services/env/siteInfo/siteInfoContext';
import {useExperiments} from '../../services/experiments/useExperiments';
import {useSiteSettings} from '../DataContainer/siteSettings/withSiteSettings';
import {MachineProvider} from '../MachineProvider';
import {IOuter} from './MechanizedApp.types';

export const MechanizedApp: React.FunctionComponent<IOuter> = ({album, track, trackId, player, children}) => {
  if (trackId) {
    track = album.tracks.find((track) => track.id === trackId);
  }
  const experimentBag = useExperiments();
  const siteSettings = useSiteSettings();
  const siteInfo = useSiteInfo();
  const biLogger = useBiLogger();
  const {email, snapshotId, transactionStatus} = getTransactionInfo();

  const initialContext = new AppContext({
    initialTransactionStatus: transactionStatus,
    snapshotId,
    email,
    experiments: experimentBag,
    siteInfo,
    siteSettings,
    album,
    track,
    player,
  });

  return (
    <MachineProvider machine={createMachine({biLogger})} initialContext={initialContext}>
      {children}
    </MachineProvider>
  );
};

MechanizedApp.displayName = 'MechanizedApp';
